import { NativeSelect } from "@mui/material";
import { FormizoSchema } from "Components/LabIZO/Formizo";
import { CustomFilterValueProps, FieldType, Filterable, TablizoSchema } from "Components/LabIZO/Tablizo";
import _ from "lodash";

const Table: TablizoSchema[] = [
  {
    label: "SessionID",
    name: "sessionID",
    filterable: true,
  },
  {
    label: "Datetime",
    name: "recTime",
    type: "dateTime",
    transform: "datetime",
    filterable: true,
    defaultSort: "desc",
  },
  {
    label: "Grade",
    name: "grade",
    valueGetter: (row: any, field: any, addOns: any) => {
      let grade = row.grade;
      return grade;
    },
    filterable: true,
    width: 80,
  },
  {
    label: "Reason",
    name: "reason",
    filterable: true,
  },
  {
    label: "Irrelevant",
    name: "irrelevant",
    filterable: true,
  },
  {
    label: "Incomplete",
    name: "incomplete",
    filterable: true,
  },
  {
    label: "relevant",
    name: "relevant",
    filterable: true,
  },
  {
    label: "complete",
    name: "complete",
    filterable: true,
  },
  {
    label: "Other Answer",
    name: "otherAnswer",
    filterable: true,
  },
  {
    label: "Selection",
    name: "selection",
    filterable: true,
  },
];

const Info: FormizoSchema[] = [
  {
    label: "ID",
    name: "_id",
    validate: ["required"],
    format: "text",
    readOnly: true,
  },
  {
    label: "SessionID",
    name: "sessionID",
    format: "text",
    readOnly: true,
  },
  {
    label: "Datetime",
    name: "recTime",
    format: "text",
    readOnly: true,
  },
  {
    label: "Grade",
    name: "grade",
    format: "text",
    readOnly: true,
  },
  {
    label: "Reason",
    name: "reason",
    format: "text",
    readOnly: true,
  },
  {
    label: "Irrelevant",
    name: "irrelevant",
    format: "text",
    readOnly: true,
  },
  {
    label: "Incomplete",
    name: "incomplete",
    format: "text",
    readOnly: true,
  },
  {
    label: "Other Answer",
    name: "otherAnswer",
    format: "text",
    readOnly: true,
  },
  {
    label: "Selection",
    name: "selection",
    format: "text",
    readOnly: true,
  },
];

const Filterables: Filterable[] = [
  {
    label: "SessionID",
    field: "sessionID",
    type: FieldType.text,
  },
  {
    label: "Grade",
    field: "grade",
    type: FieldType.number,
  },
  {
    label: "Reason",
    field: "reason",
    type: FieldType.text,
  },
  {
    label: "Irrelevant",
    field: "irrelevant",
    type: FieldType.text,
  },
  {
    label: "Incomplete",
    field: "incomplete",
    type: FieldType.text,
  },
  {
    label: "Relevant",
    field: "relevant",
    type: FieldType.text,
  },
  {
    label: "Complete",
    field: "complete",
    type: FieldType.text,
  },
  {
    label: "Other Answer",
    field: "otherAnswer",
    type: FieldType.text,
  },
  {
    label: "Selection",
    field: "selection",
    type: FieldType.text,
  },
];

const Export = [
  {
    label: "ID",
    name: "_id",
  },
  {
    label: "SessionID",
    name: "sessionID",
  },
  {
    label: "Datetime",
    name: "recTime",
  },
  {
    label: "Grade",
    name: "grade",
  },
  {
    label: "Reason",
    name: "reason",
  },
  {
    label: "Irrelevant",
    name: "irrelevant",
  },
  {
    label: "Incomplete",
    name: "incomplete",
  },
  {
    label: "relevant",
    name: "relevant",
  },
  {
    label: "complete",
    name: "complete",
  },
  {
    label: "Other Answer",
    name: "otherAnswer",
  },
  {
    label: "No. of Conversation",
    name: "numberOfConversation",
  },
  {
    label: "Selection",
    name: "selection",
  },
];

const AdvFilter: any = [];

const schema: any = {
  Table,
  Info,
  Export,
  AdvFilter,
  Filterables,
};

export default schema;
